import { FirstBlock } from '../FirstBlock';
import { Footer } from '../Footer';
import * as styles from './styles.css';

interface IContentProps {
  modal: JSX.Element | null;
  header: JSX.Element;
  doors: JSX.Element;
  prediction: JSX.Element;
}

export const Content: React.FC<IContentProps> = ({ modal, header, doors, prediction }) => {
  return (
    <div className={styles['container']}>
      {header}
      <FirstBlock />
      {doors}
      <Footer />
      {modal}
      {prediction}
    </div>
  );
};
